import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'wmLocalDateFormatter'})
export class WmLocalDateFormatterPipe implements PipeTransform {
  transform(value: Date): String {
      if (!value) {
        return ' — ' ;
      }
    try {

    let date = new Date(value);
    let monthes = [
            'января',
            'февраля',
            'марта',
            'апреля',
            'мая',
            'июня',
            'июля',
            'августа',
            'сентября',
            'октября',
            'ноября',
            'декабря'
    ];

    return  date.getDate() + ' ' + monthes[date.getMonth()] + ' ' + date.getFullYear();

    } catch (e) {
      return '';
    }
  }
}

@Pipe({name: 'wmLocalDateTimeFormatter'})
export class WmLocalDateTimeFormatterPipe implements PipeTransform {
  transform(value: Date): String {
      if (!value) {
        return ' — ' ;
      }
    try {

    let date = new Date(value);
    let monthes = [
            'января',
            'февраля',
            'марта',
            'апреля',
            'мая',
            'июня',
            'июля',
            'августа',
            'сентября',
            'октября',
            'ноября',
            'декабря'
    ];

    return  date.getDate() + ' ' + monthes[date.getMonth()] + ' ' +
      date.getFullYear() + ' в ' + date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();

    } catch (e) {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/local_date_format.pipe.ts